import { ReactElement, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Survey from '../components/survey/Survey'
import apiServices from '../libs/services'
import { LoadingSpinner } from '../components/atoms'
import { useAuth } from '../hooks/useAuth'

export const PRE_SURVEY_ID_SLUG = 'PRE_SURVEY'

function PreSurveyPage (): ReactElement {
  const navigate = useNavigate()
  const { userProfile, refreshUserProfile } = useAuth()
  const [surveyId, setSurveyId] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchSurveyMetadata = async (): Promise<void> => {
      try {
        const res = await apiServices.getSurveyByUserGeneratedId(PRE_SURVEY_ID_SLUG)
        const id = res.data?.id as string | undefined
        if (id !== undefined && id !== null) {
          // Check if already completed
          const completedIds = userProfile?.user_profile?.completed_survey_ids ?? []
          if (completedIds.includes(id)) {
            navigate('/user-dashboard', { replace: true })
            return
          }
          setSurveyId(id)
        } else {
          setError('Survey ID not found in response.')
        }
      } catch (err: any) {
        console.error('Failed to fetch survey metadata.', err)
        setError('Failed to load survey metadata.')
      } finally {
        setLoading(false)
      }
    }

    void fetchSurveyMetadata()
  }, [navigate, userProfile])

  const handleFinish = async (): Promise<void> => {
    await refreshUserProfile()
    navigate('/user-dashboard', { replace: true })
  }

  if (loading) {
    return (
      <div className='bg-dopage-black min-h-screen flex items-center justify-center'>
        <LoadingSpinner className='w-[25vmin] min-w-[80px] max-w-[240px]' />
      </div>
    )
  }

  if (error !== null || surveyId === null) {
    return (
      <div className='bg-dopage-black min-h-screen flex items-center justify-center text-red-500 font-primary'>
        {error ?? 'An unexpected error occurred.'}
      </div>
    )
  }

  return <Survey surveyId={surveyId} onFinish={handleFinish} />
}

export default PreSurveyPage
